import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import WhatsAppButton from "@/components/WhatsAppButton";
import Hero from "@/sections/Hero";
import TrustBar from "@/sections/TrustBar";
import Problems from "@/sections/Problems";
import Solutions from "@/sections/Solutions";
import HowItWorks from "@/sections/HowItWorks";
import CaseStudies from "@/sections/CaseStudies";
import WhyBangde from "@/sections/WhyBangde";
import FAQ from "@/sections/FAQ";
import FinalCTA from "@/sections/FinalCTA";

const Home = () => (
    <div data-testid="home-page" className="bg-mist">
        <Navbar />
        <main>
            <Hero />
            <TrustBar />
            <Problems />
            <Solutions />
            <HowItWorks />
            <CaseStudies />
            <WhyBangde />
            <FAQ />
            <FinalCTA />
        </main>
        <Footer />
        <WhatsAppButton />
    </div>
);

export default Home;
